var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"report-card"},[(_vm.title)?_c('div',{staticClass:"report-card-header"},[_c('div',{staticClass:"left"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"right"},[_vm._t("headerRight")],2)]):_vm._e(),_c('div',{staticClass:"report-card-content"},[_vm._t("content")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }